import React from 'react';
import { useCompany } from '@/context/CompanyContext';
import { Navigate, useLocation } from 'react-router-dom';

interface RoleGuardProps {
  children: React.ReactNode;
  allowedRoles?: Array<'admin' | 'member' | 'vendeur'>;
}

export const RoleGuard: React.FC<RoleGuardProps> = ({ children, allowedRoles = ['admin', 'member'] }) => {
  const { userRole, loading } = useCompany();
  const location = useLocation();

  // Wait until company context is ready to avoid flicker
  if (loading) {
    return null;
  }

  // Allow if role is known and included
  if (userRole && allowedRoles.includes(userRole)) {
    return <>{children}</>;
  }

  // If user doesn't have the required role, show unauthorized message
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <h1 className="text-2xl font-bold mb-4">Accès non autorisé</h1>
      <p className="text-muted-foreground">Vous n'avez pas les permissions nécessaires pour accéder à cette page.</p>
    </div>
  );
};
